class JinjaTemplate {
  encode(template: string): Record<string, string> {
    return convertTemplateObjectToObject(template);
  }

  decode(obj: Record<string, string>): string {
    return convertObjectToTemplateObject(obj);
  }
}

export const jinjaTemplate = new JinjaTemplate();

function convertTemplateObjectToObject(templateObject: string) {
  const openingBracketIndex = templateObject.indexOf('{');
  const closingBracketIndex = templateObject.lastIndexOf('}');

  const templateFields = templateObject.substring(openingBracketIndex + 1, closingBracketIndex - 1);

  const fieldsObject: Record<string, string> = {};
  templateFields
    .split('\n')
    .filter(s => !isEmpty(s))
    .forEach(templateField => {
      const preparedTemplateField = removeTrailingComma(templateField.trim());
      const [key, value] = preparedTemplateField.split(/:(.+)/);
      const trimmedKey = key.trim();
      const updatedValue = isString(value)
        ? replaceDoubleQuotesWithSingleQuotes(value.trim())
        : value;

      fieldsObject[trimmedKey] = updatedValue;
    });

  return fieldsObject;
}

function convertObjectToTemplateObject(obj: Record<string, string>) {
  let templateObject = '';
  Object.entries(obj).forEach(([key, value]) => {
    const updatedValue = isString(value) ? value.replace(/'/g, `"`) : value;
    templateObject = `${templateObject}${key}:${updatedValue},\n`;
  });
  return `{${templateObject.slice(0, -2)}}`;
}

function isString(val: any) {
  return typeof val === 'string';
}

function isEmpty(str: string) {
  return !str.replace(/\s/g, '');
}

function replaceDoubleQuotesWithSingleQuotes(str: string) {
  return str.replace(/"/g, `'`);
}

function removeTrailingComma(str: string) {
  return str.replace(/(,$)/g, '');
}

/*

  if (showForm) {
    return (
      <List withPadding listStyleType="none">
        <Formik
          onSubmit={handleSubmit}
          initialValues={encodedTransformation}
          render={({ values }) => {
            return (
              <Form>
                <Box
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: '20px',
                  }}
                >
                  {Object.keys(values).map(key => {
                    return <TextInput label={key} name={key} required></TextInput>;
                  })}
                </Box>
              </Form>
            );
          }}
        ></Formik>
      </List>
    );
  }

*/

export function nunjucksParser(code) {
  const parser = require('nunjucks/src/parser');
  let errorMessage, errorLineNo;
  try {
    parser.parse(`${code}`);
  } catch (error) {
    errorLineNo = error.lineno;
    errorMessage = error.message;
  }

  if (errorLineNo) {
    return `line No ${String(errorLineNo)} ${errorMessage}`;
  }

  return '';
}
